import React, { useState } from "react";
import { Button, Modal, Tooltip, Row, Tag, Space, Alert, Statistic, Spin, Col, Result } from "antd";
import {
  SendOutlined,
  LeftOutlined,
  ExclamationCircleOutlined
} from "@ant-design/icons";
import { useSelector, useDispatch } from "react-redux";
import { currentUserSelector } from "views/Auth/Login/selector";
import { useTranslate } from "lib/MrTranslate/MrTranslate";

const IBFields = (props) => {

  const { segment } = props
  const currentUser = useSelector(currentUserSelector())
  const mrIntl = useTranslate()
  console.log('segment', segment.custom_fields);

  let finalRender = []

  if(currentUser.role === "qb_author"){
    let innerRender = []
    segment.custom_fields.ib_reference_code && innerRender.push(<Tag color="yellow" title={mrIntl("CommonText.ib_reference_code")}>{segment.custom_fields.ib_reference_code}</Tag>)
    segment.custom_fields.ib_question_type && innerRender.push(<Tag color="orange" title={mrIntl
    ("CommonText.ib_question_type")}>{segment.custom_fields.ib_question_type}</Tag>)
    // segment.teaching_level_label && innerRender.push(<Tag color="blue" title="Teaching level">{segment.teaching_level_label}</Tag>)
    // segment.difficulty_level_label && innerRender.push(<Tag color="green" title="Difficulty level">{segment.difficulty_level_label}</Tag>)
    finalRender = innerRender.length ? <React.Fragment>
      <Row style={{ marginTop: "20px" }}>
        <Col span={24}>{innerRender}</Col>
      </Row>
    </React.Fragment> : ""
  }


  return finalRender

};

export default IBFields;
